import fetch from 'utils/fetch'

// 获取accessToken/refreshToken
export function appLogin(data, other) {
  return fetch({
    method: 'POST',
    url: '/reservation/appUser/login',
    data,
    ...other
  })
}

// 用户信息
export function fetchUser(params, other) {
  return fetch({
    url: '/reservation/appUser/information',
    params,
    ...other
  })
}

// 家庭信息
export function fetchFamily(params, other) {
  return fetch({
    url: '/reservation/appUser/family/member',
    method: 'GET',
    params,
    ...other
  })
}
//家庭人员详细档案
export function getRecordDetail({id}) {
  return fetch({
    url: '/reservation/appProfile/'+id,
    method: 'GET',
   
  })
}
//下拉刷新家庭档案
export function onloadFamily() {
  return fetch({
    url: '/reservation/appUser/refreshChildProfile',
    method:'GET'
  })
}
//添加家庭成员档案搜索
export function addFamilyRecord(params) {
  return fetch({
    url: '/reservation/appProfile/searchApp',
    method: 'GET',
    params,
    
  })
}
// 取消预约
export function cancleApplay(data, other = {}) {
  return fetch({
    url: `/reservation/appReservation/cancelOrder`,
    method: 'POST',
    data,
    ...other
  })
}
//删除家庭成员
export function delFamilyRecord(id) {
  return fetch({
    url: '/reservation/appProfile/family/'+id,
    method: 'DELETE'
  })
}
//获取二维码
export function getQRcode(profileCode) {
  return fetch({
    url: '/reservation/appProfile/qrcode/'+profileCode,
    method: 'GET',
    
  })
}
//请求档案授权
export function requestRecord(data) {
  return fetch({
    method: 'POST',
    url: '/reservation/appProfile/requireProfileAuth',
    data
  })
}
// 上一次接种的人
export function fetchReccentMember() {
  return fetch({
    url: '/reservation/appReservation/last/profile'
  })
}
// 预约列表
export function getAppReservation(params, other = {}) {
  return fetch({
    url: `/reservation/appReservation/appReservationDetailList`,
    method: 'GET',
    params,
    ...other
  })
}
// 预约详情
export function getReservationDetail(id, params, other = {}) {
  return fetch({
    url: `/reservation/appReservationDetail/app/${id}`,
    method: 'GET',
    params,
  })
}
// 接种点我的家庭成员
export function getAppVaccineMember(params, other = {}) {
  return fetch({
    url: `/reservation/appUser/vaccinePoint/member`,
    method: 'GET',
    params,
    ...other
  })
}
// 获取档案门诊列表
export function getPovPage(params) {
  return fetch({
    url: `/master/maPov/appPage`,
    method: 'GET',
    params,
  })
}
// 更新档案 / 迁卡
export function updateAppProfile(id,data) {
  return fetch({
    url: `/reservation/appProfile/${id}`,
    method: 'put',
    data,
  })
}
/**
 * 门诊信息
 *
 */
export function searchPovCode(params, other = {}) {
  return fetch({
    url: `/reservation/appProfile/qrCode/parse/povCode`,
    method: 'GET',
    params,
    ...other
  })
}
// 新生儿建档
export function getSaveChildCard(data, other = {}) {
  return fetch({
    url: `/reservation/appProfile/saveChildCard`,
    method: 'POST',
    data,
    ...other
  })
}